import { type } from "os";
export function simple_deep_equal(a, b) {
  return JSON.stringify(a) === JSON.stringify(b);
}
export function xpath(xpathToExecute, doc) {
  var result = [];

  var resolver = function resolver(prefix) {
    if (prefix === 'b') {
      return 'https://developers.google.com/blockly/xml';
    } else {
      return null;
    }
  };

  var nodesSnapshot = document.evaluate(xpathToExecute, doc, resolver, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);

  for (var i = 0; i < nodesSnapshot.snapshotLength; i++) {
    result.push(nodesSnapshot.snapshotItem(i));
  }

  return result;
}
export function json_parse(s) {
  if (!s) {
    return null;
  }

  try {
    s = s.trim();
    var v = JSON.parse(s);
    return v;
  } catch (e) {
    console.error(e);
    return null;
  }
}
export function debounce(func, wait) {
  var timeout;
  return function debouncedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var context = this;

    var later = function later() {
      timeout = null;
      func.apply(context, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}
export function all_the_same(elts, _ref) {
  var _ref$cmp = _ref.cmp,
      cmp = _ref$cmp === void 0 ? function (a, b) {
    return a == b;
  } : _ref$cmp;

  if (!elts) {
    return false;
  }

  if (elts.length === 0) {
    return true;
  }

  var first = elts[0];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = elts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var elt = _step.value;

      if (!cmp(first, elt)) {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return true;
}
export function random_id(len) {
  var id = ''; // build in 8 char chunks from random

  for (var i = 0; i < Math.floor(len / 8); i++) {
    id += Math.random().toString(36).substr(2, 8);
  }

  id += Math.random().toString(36).substr(2, len % 8);
  return id;
} //function hash_code(str) {
//  return str.split('').reduce((prevHash, currVal) =>
//    (((prevHash << 5) - prevHash) + currVal.charCodeAt(0))|0, 0);
//}

export function encode_some_entities(str) {
  return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
export function is_empty_str(str) {
  return !str || str.length === 0 || !str.trim();
}
export function validate_str(str) {
  // Check whether given str only contains lower case letters, numbers and - or _
  if (typeof str !== 'string') return null;
  var regexp = str.replace(/^[a-z0-9-_[]*$/, '');
  if (str.length === 0 || regexp) return null;
  return str;
}
export function validate_date(input) {
  // trim input to get rid of whitespaces
  input = input.trim();
  var parts = input.split('-'); // Make sure that string contains date format YYYY-MM-DD

  if (input.length === 0) return '';
  if (parts.length !== 3) return null;

  if (parts[0].length === 0 || parts[1].length === 0 || parts[2].length === 0) {
    return null;
  }

  var input_date = new Date(input);
  if (isNaN(input_date)) return null;
  if (input_date.getDate() !== Number(parts[2])) return null;
  return input_date;
}
export function validate_start_and_end_date(_ref2) {
  var start = _ref2.start,
      end = _ref2.end;
  // Check whether start and end date string are valid and return them or null
  var start_date = validate_date(start);
  var end_date = validate_date(end);
  if (start_date === null || end_date === null) return null;
  if (end_date.length !== 0 && start_date > end_date) return null;
  start_date = start_date.length === 0 ? start_date : start_date.toISOString().substr(0, 10);
  end_date = end_date.length === 0 ? end_date : end_date.toISOString().substr(0, 10);
  return {
    start: start_date,
    end: end_date
  };
}